import React from 'react';
import { useTranslation } from 'react-i18next';

const FileUpload = ({ onFilesSelected, fileInputRef }) => {
  const { t } = useTranslation();
  
  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.classList.add('dragover');
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove('dragover');
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove('dragover');
    const files = e.dataTransfer.files;
    onFilesSelected(files);
  };

  const handleFileSelect = (e) => {
    const files = e.target.files;
    onFilesSelected(files);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="card">
      <div className="card-content">
        <div
          className="upload-area"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          onClick={handleClick}
        >
          <h3>{t('upload.title')}</h3>
          <p style={{ fontSize: '14px', color: '#666', marginTop: '8px' }}>{t('upload.supportedFormats')}</p>
          <button className="btn">{t('upload.button')}</button>
          <input
            ref={fileInputRef}
            type="file"
            className="file-input"
            multiple
            accept=".cbz,.cb7,.zip,.docx,.pdf"
            onChange={handleFileSelect}
          />
        </div>
      </div>
    </div>
  );
};

export default FileUpload;
